"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardLabelSchema = void 0;
var _zod = require("zod");
var cardLabelSchema = t => {
  return _zod.z.object({
    cardLabel: _zod.z.string().min(1, t('cards.centrallyStoredCard.card.label.required')).max(20, t('cards.centrallyStoredCard.card.label.required'))
  });
};
exports.cardLabelSchema = cardLabelSchema;